module.exports = __webpack_public_path__ + "52fe25a47b082a7e303ffa46852cc24b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/new-logo.png
// module id = 1229
// module chunks = 0